import { Box } from '@mui/material';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { Stack } from '@mui/system';
import { jsonPathToValue } from '../../utils/json';
import useMetaData from '../../hooks/useMetaData';
import Typography from '../../components/Typography/Typography';
import FieldList, { Field } from './FieldList';
import TabLoader from './TabLoader';

interface Props {
  module: string;
  subModule: string;
  getDataMethod: (id: string) => any;
}

interface IPills {
  title: string;
  fieldValues: Field[];
}

const CategoryComponent = (props: Props) => {
  const { getDataMethod, module, subModule } = props;
  const { reservationId } = useParams<{ reservationId: string }>();
  const [data, setData] = useState<any>();
  const uiMeta = useMetaData(module, subModule);

  useEffect(() => {
    if (reservationId) {
      getDataMethod(reservationId).then((response: any) => setData(response));
    }
  }, [getDataMethod, reservationId, subModule]);

  const metaFields: IPills[] = useMemo(() => {
    return data
      ? uiMeta?.category.map(({ title, rows }: any) => ({
          title,
          fieldValues: rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              field: row?.propertyName,
              value: row.type === 'Date' ? value && moment(value).format('MMM D, YYYY') : value || '--',
            };
          }),
        }))
      : [];
  }, [data, uiMeta?.category]);

  const renderMetaTabs = ({ title, fieldValues }: IPills, index: number) => {
    return (
      <Fragment key={`Pills${index}`}>
        <Typography size={12} weight={500} uppercase paddingLeft={1.5}>
          {title}
        </Typography>
        <FieldList fields={fieldValues} />
      </Fragment>
    );
  };

  if (!metaFields || !data) {
    return <TabLoader />;
  }

  return <Box>{metaFields.map(renderMetaTabs)}</Box>;
};

export default CategoryComponent;
